var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-related" }, [
    _c("span", { staticClass: "viq-related__label" }, [
      _vm._v("Related topics"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-related__cards" },
      _vm._l(_vm.topics, function (topic, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "viq-related__card",
            on: {
              click: function ($event) {
                return _vm.openTopic(topic)
              },
            },
          },
          [
            topic.type
              ? _c("span", { staticClass: "viq-related__card-type" }, [
                  _vm._v(_vm._s(topic.type)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("h5", { staticClass: "viq-related__card-title" }, [
              _vm._v(_vm._s(topic.title || topic)),
            ]),
            _vm._v(" "),
            topic.jurisdiction
              ? _c("span", { staticClass: "viq-related__card-jurisdiction" }, [
                  _vm._v(
                    "\n        " + _vm._s(topic.jurisdiction) + "\n      "
                  ),
                ])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }